import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title-1" }, "Importer des données", -1)
const _hoisted_3 = { class: "row gap-2 items-stretch" }

import { useUser } from "@/domains/auth/user";
import ImportData from "../components/ImportData.vue";
import ImportUserEmails from "../components/ImportUserEmails.vue";
import { ABILITY_READ_RESTRICTED_CRUDS } from "@/domains/cruds/users/users";
import { computed, ref, watch } from "vue";
import ImportResource from "../components/ImportResource.vue";
import {
    ADMINISATRATION_LEVEL_DELEGATE,
    Department,
} from "@/domains/cruds/departments/departments";
import { request } from "@/domains/api/api";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser();
const hasRestrictedCrudAbility = computed(
    () =>
        user.value?.abilities?.includes(ABILITY_READ_RESTRICTED_CRUDS) === true
);

const canImportForDep = ref(false);
watch(
    user,
    (u) => {
        if (!u?.department_id) return;
        canImportForDep.value = false;
        request<Department>("departments/" + u.department_id, "get")
            .then((d) => {
                if (d)
                    canImportForDep.value =
                        d.administration_level ===
                        ADMINISATRATION_LEVEL_DELEGATE;
            })
            .catch(() => (canImportForDep.value = false));
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(hasRestrictedCrudAbility))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(ImportData),
            _createVNode(ImportUserEmails)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(ImportResource, {
        resourceName: "Lieux",
        resourceKey: "locations",
        "excel-description": "1 colonne nom du lieux, seulement les valeurs",
        "import-url": "import/locations",
        canImportForDep: canImportForDep.value
      }, null, 8, ["canImportForDep"]),
      _createVNode(ImportResource, {
        resourceName: "GIC",
        resourceKey: "gics",
        "excel-description": "1 colonne nom du GIC, seulement les valeurs",
        "import-url": "import/gics",
        canImportForDep: canImportForDep.value
      }, null, 8, ["canImportForDep"]),
      _createVNode(ImportResource, {
        resourceName: "Demandeurs",
        resourceKey: "requesters",
        "excel-description": "1 colonne nom du demandeur, 1 colonne s'il est membre (1) ou non (0), seulement les valeurs",
        "import-url": "import/requesters",
        canImportForDep: canImportForDep.value
      }, null, 8, ["canImportForDep"])
    ])
  ]))
}
}

})